interface PricingProps {
  onQuoteClick: () => void;
}

export default function Pricing({ onQuoteClick }: PricingProps) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            料金について
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8 max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 border-pink-100 p-8 rounded-2xl border-2 hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl mb-4">
              <i className="ri-global-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">海外論文</h3>
            <div className="mb-2">
              <span className="text-3xl font-bold text-blue-600">2,100円</span>
              <span className="text-gray-600">〜(税抜)</span>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-teal-50 border-green-100 p-8 rounded-2xl border-2 hover:shadow-xl transition-shadow">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-600 rounded-xl mb-4">
              <i className="ri-book-line text-2xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-4">国内論文</h3>
            <div className="mb-2">
              <span className="text-3xl font-bold text-blue-600">2,600円</span>
              <span className="text-gray-600">〜(税抜)</span>
            </div>
          </div>
        </div>
        
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 mb-8 max-w-4xl mx-auto">
          <div className="flex items-start gap-3">
            <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-blue-600"></i>
            </div>
            <div className="text-sm text-gray-700 space-y-1">
              <p>※実際の金額は論文・出版社・著作権料により異なります。</p>
              <p>※見積は無料です。</p>
            </div>
          </div>
        </div>
        
        <div className="text-center">
          <button 
            onClick={onQuoteClick}
            className="group bg-blue-600 text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-calculator-line"></i>
            無料見積もりを依頼する
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
}